import React, { useState, useEffect } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import { EditOutlined } from "@ant-design/icons";
import EditableFieldMappingTree from "./EditableFieldMappingTree";

function Field_mapping(props) {
    // Example data-fetching function
    const getData = () => {
        let apitoken = localStorage.getItem("api_token");
        sendRequest({
            method: "GET",
            url: `${process.env.REACT_APP_BASE_URL}/mongo/get/configuration_master/view_payload_structure`,
            headers: {
                "api-token": apitoken,
            },
        }).then((response) => {
            setVal(response);
        });
    };

    useEffect(() => {
        getData();
    }, []);

    const [loading, sendRequest] = useAxios();
    const [isErrOpen, setisErrOpen] = useState(false);
    const [api_error_message, setapi_error_message] = useState();
    const [mapping_name, setmapping_name] = useState();
    const [textareaVisible, setTextareaVisible] = useState(false);
    const [inputJson, setInputJson] = useState("");
    const [configedJson, setConfigedJson] = useState({ 'editMe': '' });
    const [val, setVal] = useState([]);
    const [showMore, setShowMore] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [filters, setFilters] = useState({});
    const [objectid, setObjectid] = useState();

    const eventNameSearch = (e, columnName) => {
        const updatedFilters = { ...filters, [columnName]: e.target.value };
        setFilters(updatedFilters);
    };
    const filterData = () => {
        return val.filter((row) => {
            for (const columnName in filters) {
                const filterText = filters[columnName].toLowerCase();
                const cellText = String(row[columnName]).toLowerCase();
                if (!cellText.includes(filterText)) {
                    return false;
                }
            }
            return true;
        });
    };
    const handleEdit = (index,objectid) => {
        setObjectid(objectid);
        const item = val[index];
        setConfigedJson(item.configedJson);
        setmapping_name(item.name || item.mapping_name || '');
        setEditIndex(index);
    };

    const handleCreateFromSample = (e) => {
        try {
            const input = JSON.parse(inputJson.trim());
            setConfigedJson(input);
        }
        catch (e) {
            alert("invalid JSON")
        }
    }

    const handleSave = async (e) => {
        let apitoken = localStorage.getItem("api_token");
        try {
            const url = editIndex !== null
                ? `${process.env.REACT_APP_BASE_URL}/mongo/updateone/configuration_master/view_payload_structure/${objectid}`
                : `${process.env.REACT_APP_BASE_URL}/mongo/insert/configuration_master/view_payload_structure`;

            //const method = editIndex !== null ? "PUT" : "POST";
console.log("url",url);
            const requestData = {
                "mapping_name": mapping_name,
                "configedJson": configedJson
            };

            // If updating, add the document ID or filter criteria
            if (editIndex !== null) {
                //requestData.filter = { "_id": val[editIndex]._id }; // or use appropriate identifier
            }

            const response = await sendRequest({
                method: "POST",
                url: url,
                headers: {
                    "api-token": apitoken,
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(requestData)
            });

            if (response.status == 1) {
                setisErrOpen(true);
                setapi_error_message(response.message);
                // Reset edit state after successful update
                if (editIndex !== null) {
                    setEditIndex(null);
                }
            }
        }
        catch (e) {
            setisErrOpen(true);
            setapi_error_message(e.message);
        }
    }

    const filteredData = filterData();
    return (
        <div className="container">
            <Commonheader pagetitle={"Create Field Mapping"} props={props} />
            {loading && (
                <div className="load-4">
                    <div className="ring-1"></div>
                </div>
            )}
            <div
                className={
                    isErrOpen
                        ? "modal fade show d-block mymodal"
                        : "modal fade bd-example-modal-sm"
                }
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                id="confirm-box"
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content cdb-confirm-box col-sm-12">
                        <button
                            type="button"
                            className="close text-right"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={() => {
                                setisErrOpen(false);
                                window.location.reload();
                            }}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <p className="popuperrtext">{api_error_message}</p>
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <div className="viewname-holder">
                    <div className="form-group">
                        <div className="form-group col-md-2 mw-100 needs-validation">
                            <label htmlFor="inputEmail4">Mapping Name :</label>
                            <input
                                name="mapping_name"
                                className="form-control"
                                placeholder="Enter Name"
                                value={mapping_name}
                                required
                                onChange={(e) => setmapping_name(e.target.value)}
                            />
                        </div>
                        <div>
                            <div className="d-flex justify-content-between">
                                <span>Json Config: </span>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => { setTextareaVisible(true) }}
                                >
                                    Create from Json sample
                                </button>
                            </div>
                            {
                                textareaVisible &&
                                <div className="mb-3">
                                    <div>
                                        <textarea value={inputJson} rows="4" onChange={(e) => { setInputJson(e.target.value) }} style={{ width: '100%', marginTop: '10px', padding: '20px' }} placeholder="Enter valid JSON..."></textarea>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div></div>
                                        <div>
                                            <button
                                                className="btn btn-primary mr-2"
                                                onClick={() => { setTextareaVisible(false) }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => { setTextareaVisible(false); handleCreateFromSample() }}
                                            >
                                                Create Config
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                !textareaVisible &&
                                <EditableFieldMappingTree
                                    data={configedJson}
                                    onChange={(newData) => setConfigedJson(newData)}
                                />
                            }
                        </div>
                        <div>
                            <button className="btn btn-primary" onClick={() => { handleSave() }}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-4">
                <table className="table table-bordered">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col" className="w-25 position-relative">
                                Vendor Name
                                <br />
                                <input
                                    placeholder="Search Mapping Name"
                                    name="mapping_name"
                                    className="form-control"
                                    type="text"
                                    value={filters["mapping_name"]}
                                    onChange={(e) => eventNameSearch(e, "mapping_name")}
                                />
                            </th>
                            <th>Payload Fields
                                <br />
                                <input
                                    placeholder="Search Payload Field"
                                    name="configedJson"
                                    className="form-control"
                                    type="text"
                                    value={filters["configedJson"]}
                                    onChange={(e) => eventNameSearch(e, "configedJson")}
                                /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length > 0 && filteredData.map((list, index) => (
                            <tr key={index}>
                                <td>{list.mapping_name}</td>
                                <td>
                                    {showMore === index
                                        ? JSON.stringify(list.configedJson)
                                        : list.configedJson !== undefined
                                            ? `${JSON.stringify(list.configedJson).slice(0, 60)}`
                                            : ""}
                                    {showMore === index ? (
                                        <>
                                            <button className="btn" onClick={() => setShowMore(null)}>
                                                showLess
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button className="btn" onClick={() => setShowMore(index)}>
                                                showMore....
                                            </button>
                                        </>
                                    )}
                                    <button className="btn" onClick={() => handleEdit(index,list._id.$oid)}>
                                        Edit
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Field_mapping